<template>
  <div :class="'md-layout-item'">
    <div :class="'md-layout-item md-size-100'">
      <span
        :class="'md-body-1'"
        v-bind:style="answered ? '' : 'color: #ef4225;'"
        >{{ question.text }}</span
      >
    </div>
    <div :class="'md-layout-item md-size-100'">
      <md-field>
        <label>Answer</label>
        <md-input
          type="text"
          v-model="field"
          :disabled="isDisabled"
          :maxlength="question.maxlength"
          @blur.prevent="send"
        />
        <md-button
          :class="'md-simple md-just-icon'"
          @click.prevent="openMapLink"
          v-if="question.field === 'map_link'"
        >
          <md-icon>link</md-icon>
        </md-button>
      </md-field>
    </div>
    <div :class="'md-layout-item md-size-100'">
      <md-field>
        <label>Observation</label>
        <md-input
          type="text"
          v-model="observation"
          :disabled="isDisabled"
          :maxlength="100"
          @blur.prevent="send"
        />
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    answer: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    answered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      field: "",
      observation: "",
    };
  },
  methods: {
    send() {
      const id = this.$route.params.id;
      const data = this.getAnswer();

      // Permite enviar respostas vazias para limpar a resposta no servidor
      this.$api.request
        .post(`reviews/${id}/answers`, data)
        .then((response) => {
          this.$emit("post-sent", {
            question: this.question.id || response.data[0]["question_id"],
            answerData: data.answers[0], // Incluir os dados da resposta atualizada
          });
        })
        .catch(() => {
          this.$toast.warning("Please, try again.", "");
        });
    },
    getAnswer() {
      return {
        section: this.getSection(),
        type: this.question.type,
        answers: [
          {
            question_id: this.question.id,
            answer: this.field,
            text: this.observation,
          },
        ],
      };
    },
    getSection() {
      switch (this.$parent.mdLabel) {
        case "Engagement Leader":
          return "engagement_leader";
        case "Manager":
          return "manager";
        default:
          return "reviewer";
      }
    },

    openMapLink() {
      window.open(this.field, "_blank");
    },
  },
  mounted() {
    this.field = this.answer.answer;
    this.observation = this.answer.text;
  },
};
</script>
